import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { toast } from 'sonner';

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { googleLogin } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      // Extract session_id from URL hash or query
      const hash = location.hash || window.location.hash;
      const match = hash.match(/session_id=([^&]+)/);
      
      if (!match) {
        toast.error('Invalid session');
        navigate('/login');
        return;
      }

      const sessionId = match[1];

      try {
        await googleLogin(sessionId);
        toast.success('Signed in with Google!');
        navigate('/dashboard', { replace: true });
      } catch (err) {
        const status = err?.response?.status;
        const serverDetail = err?.response?.data?.detail;
        const message = err?.message;
        // Surface the real underlying failure so we can diagnose OAuth issues
        // (e.g. Emergent OAuth session exchange rejected, unwhitelisted domain, etc.)
        // instead of hiding it behind a generic toast.
        console.error('[AuthCallback] Google sign-in failed', {
          status,
          serverDetail,
          message,
          responseData: err?.response?.data,
          error: err,
        });
        const humanDetail = serverDetail || message || 'Unknown error';
        toast.error(
          `Google sign-in failed${status ? ` (${status})` : ''}: ${humanDetail}`,
          { duration: 8000 }
        );
        navigate('/login');
      }
    };

    processSession();
  }, [location, navigate, googleLogin]);

  return (
    <div className="min-h-screen bg-[#111111] flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin w-12 h-12 border-4 border-[#22C55E] border-t-transparent rounded-full mx-auto mb-4"></div>
        <p className="text-[#999999]">Signing you in...</p>
      </div>
    </div>
  );
}
